// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"explore"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M4.92893 19.0711C1.02369 15.1659 1.02369 8.83424 4.92893 4.92899C8.83417 1.02375 15.1658 1.02375 19.0711 4.92899C22.9763 8.83424 22.9763 15.1659 19.0711 19.0711C15.1658 22.9764 8.83418 22.9764 4.92893 19.0711Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M7.40039 11.4928L15.7017 8.29999L12.5089 16.6012L11.1581 12.8436L7.40039 11.4928Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M4.92893 19.0711C1.02369 15.1659 1.02369 8.83424 4.92893 4.92899C8.83417 1.02375 15.1658 1.02375 19.0711 4.92899C22.9763 8.83424 22.9763 15.1659 19.0711 19.0711C15.1658 22.9764 8.83418 22.9764 4.92893 19.0711Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M7.40039 11.4928L15.7017 8.29999L12.5089 16.6012L11.1581 12.8436L7.40039 11.4928Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-explore')
export default class ExploreIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'explore',
    }
  }
}
